export const SCENARIO_LIST = [
    {
        id: 1,
        name: 'Scenario 1',
        title: 'Scenario 1',
        description: 'Negative client ROI w high RM revenue',
        path: '/s1',
        isHovered: false,
        isSelected: undefined,
        info: {
            description:
                'Identify RMs who have high revenue but also have a high number of portfolios that are incurring net losses',
            criticalRatio:
                'Proportion of portfolio unrealized losses as compared to RM revenue'
        }
    },
    {
        id: 2,
        name: 'Scenario 2',
        title: 'Scenario 2',
        description: 'Persistent dynamic suitability breaches',
        path: '/s2',
        isHovered: false,
        isSelected: undefined,
        info: {
            description:
                'Identify RMs who have executed a high number of trades that triggered portfolio risk mismatch and/or concentration risk alerts',
            criticalRatio: '% Suitability alerts'
        }
    },
    {
        id: 3,
        name: 'Scenario 3',
        title: 'Scenario 3',
        description: 'High number of execution only trades',
        path: '/s3',
        isHovered: false,
        isSelected: undefined,
        info: {
            description:
                'Identify RMs who have executed a high number of execution only trades for specific products',
            criticalRatio: '% Execution only trades on specific products'
        }
    },
    {
        id: 4,
        name: 'Scenario 4',
        title: 'Scenario 4',
        description: 'High instances of concentrated execution only trades',
        path: '/s4',
        isHovered: false,
        isSelected: undefined,
        info: {
            description:
                'Identify RMs who have executed a high number of execution only trades of the same product to multiple clients within one month',
            criticalRatio:
                'Number of instances where the same product is sold to multiple clients on execution only basis within one month'
        }
    }
];

export const ROUTE_LIST = [
    {
        id: 1,
        name: 'Scenario 1',
        title: 'Scenario 1',
        description: 'Negative client ROI w high RM revenue',
        path: '/s1',
        isHovered: false,
        isSelected: undefined,
        info: {
            description:
                'Identify RMs who have high revenue but also have a high no. of portfolios that are incurring net losses.',
            criticalRatio: 'Proportion of PnL changes as compared to RM revenue'
        }
    },
    {
        id: 2,
        name: 'Scenario 2',
        title: 'Scenario 2',
        description: 'Persistent dynamic suitability breaches',
        path: '/s2',
        isHovered: false,
        isSelected: undefined,
        info: {
            description:
                'Identify RMs who have executed a high number of trades that triggered portfolio risk mismatch and/or concentration risk alerts',
            criticalRatio: '% Suitability alerts'
        }
    },
    {
        id: 3,
        name: 'Scenario 3',
        title: 'Scenario 3',
        description: 'High number of execution only trades',
        path: '/s3',
        isHovered: false,
        isSelected: undefined,
        info: {
            description:
                'Identify RMs who have executed a high number of execution only trades for specific products',
            criticalRatio: '% Execution only trades on specific products'
        }
    },
    {
        id: 4,
        name: 'Scenario 4',
        title: 'Scenario 4',
        description: 'High instances of concentrated execution only trades',
        path: '/s4',
        isHovered: false,
        isSelected: undefined,
        info: {
            description:
                'Identify RMs who have executed a high number of execution only trades of the same product to multiple clients',
            criticalRatio:
                'No. of instances where the same product is sold to multiple clients'
        }
    },
    {
        id: 5,
        name: 'Home',
        title: 'Home',
        description: 'Home',
        path: '/',
        isHovered: false,
        isSelected: undefined
    },
    {
        id: 6,
        name: 'Market View',
        title: 'Market View',
        description: 'Market View',
        path: '/market',
        isHovered: false,
        isSelected: undefined
    },
    {
        id: 7,
        name: 'Team View',
        title: 'Team View',
        description: 'Team View',
        path: '/team',
        isHovered: false,
        isSelected: undefined
    },
    {
        id: 8,
        name: 'RM View',
        title: 'RM View',
        description: 'RM View',
        path: '/rm',
        isHovered: false,
        isSelected: undefined
    }
];

export const RM_SEARCH_LABEL = 'Search CTO Code';
